var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',{staticClass:"mb-sm-5",attrs:{"id":"app"}},[_c('vue-progress-bar'),_c('snackbar'),_c(_vm.$route.meta.layout,{tag:"component",class:{
				appDark: _vm.$vuetify.theme.isDark,
				appLight: !_vm.$vuetify.theme.isDark,
			}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }